"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCreatorWizard = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _shared_1 = require("../_shared");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/components/form-parts/file-upload/component");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const _routeSearch_1 = __importStar(require("@front/pages/settings/social-media-gate/_routeSearch"));
component_2.FileUploadPart;
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.creatorOpen, (0, fast_element_1.html) `
<div class="cs-creator-overlay">

    <div class="cs-creator-topbar">
        <div class="cs-creator-title">
            <div class="cs-creator-icon"><i class="iconsminds-magic-wand"></i></div>
            <div>
                <strong>${'socialMediaPlan.creator.title'.t()}</strong>
                <small>${'socialMediaPlan.creator.subtitle'.t()}</small>
            </div>
        </div>
        <div class="cs-creator-steps">
            ${(0, fast_element_1.repeat)(x => [1, 2, 3], (0, fast_element_1.html) `
            <div class="cs-step ${(n, c) => c.parent.creatorStep === n ? 'active' : (c.parent.creatorStep > n ? 'done' : '')}">
                <span class="cs-step-num">${n => n}</span>
                <span class="cs-step-label">${(n, c) => ['socialMediaPlan.step.brief', 'socialMediaPlan.step.preview', 'socialMediaPlan.step.schedule'][n - 1].t()}</span>
            </div>
            ${(0, fast_element_1.when)(n => n < 3, (0, fast_element_1.html) `<div class="cs-step-sep"></div>`)}
            `)}
        </div>
        <button class="btn-cs-outline" @click="${x => x.close()}">&times; ${'socialMediaPlan.close'.t()}</button>
    </div>

    <div class="cs-creator-body">

        
        <div class="pc-card mb-3" style="${x => x.needsVideoUpload() && x.creatorStep > 1 ? '' : 'display:none'}">
            <div class="pc-label"><i class="iconsminds-video"></i> ${'socialMediaPlan.creator.videoUpload'.t()}</div>
            <div class="pc-hint mb-2">${'socialMediaPlan.creator.videoUploadHint'.t()}</div>
            <part-file-upload
                name="video"
                mode="file"
                accept="video/*"
                placeholder="${'socialMediaPlan.creator.videoChoose'.t()}"
                :uploadStarted="${x => x.uploadingVideo}"
                :uploadProgress="${x => x.videoUploadProgress}"
                :onSelectFile="${(x) => (e) => x.handleVideoFileSelect(e)}"
            ></part-file-upload>
            ${(0, fast_element_1.when)(x => !!x.pendingVideoFile && !x.uploadingVideo, (0, fast_element_1.html) `
            <div class="d-flex align-items-center mt-2" style="gap:8px;font-size:.82rem;color:#6B7180;">
                <i class="iconsminds-video" style="color:var(--cs-primary)"></i>
                <span class="flex-grow-1">${x => { var _a; return (_a = x.pendingVideoFile) === null || _a === void 0 ? void 0 : _a.name; }}</span>
                <button class="btn btn-outline-danger btn-sm" @click="${x => x.clearVideo()}" title="${'socialMediaPlan.creator.videoRemove'.t()}"><i class="simple-icon-trash"></i></button>
            </div>
            `)}
            ${(0, fast_element_1.when)(x => x.savingPost && !!x.publishingVideoPlatform, (0, fast_element_1.html) `
            <div class="d-flex align-items-center mt-2" style="gap:8px;">
                <i class="iconsminds-video" style="color:var(--cs-primary);flex-shrink:0;"></i>
                <div class="flex-grow-1">
                    <div style="font-size:.72rem;color:#6B7180;margin-bottom:3px;">${x => x.publishingVideoPlatform} &mdash; ${x => x.publishingVideoProgress}%</div>
                    <div style="height:5px;background:#E2E5EA;border-radius:3px;overflow:hidden;">
                        <div style="height:100%;background:var(--cs-primary);border-radius:3px;transition:width .4s;width:${x => x.publishingVideoProgress}%;"></div>
                    </div>
                </div>
            </div>
            `)}
        </div>

        
        ${(0, fast_element_1.when)(x => x.creatorStep === 1, (0, fast_element_1.html) `
        <div class="cs-creator-step">
            <div class="row">
                <div class="col-lg-8">
                    <div class="pc-card mb-3">
                        <div class="pc-label"><i class="iconsminds-pen"></i> ${'socialMediaPlan.brief.topic'.t()}</div>
                        <textarea class="form-control" rows="3" placeholder="${'socialMediaPlan.brief.topicPlaceholder'.t()}"
                            :value="${x => x.briefTopic}" @input="${(x, c) => { x.briefTopic = c.event.target.value; }}"></textarea>
                    </div>
                    <div class="pc-card mb-3">
                        <div class="pc-label"><i class="simple-icon-target"></i> ${'socialMediaPlan.brief.goal'.t()}</div>
                        <div class="row">
                            ${(0, fast_element_1.repeat)(x => x.goalOptions, (0, fast_element_1.html) `
                            <div class="col-6 col-md-4 mb-2">
                                <div class="goal-card ${(g, c) => c.parent.creatorGoal === g.label ? 'selected' : ''}" @click="${(g, c) => { c.parent.creatorGoal = g.label; }}">
                                    <i class="${g => g.icon || 'iconsminds-idea'}"></i><div class="goal-title">${g => g.label}</div>
                                </div>
                            </div>
                            `)}
                        </div>
                    </div>
                    <div class="pc-card mb-3">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <div class="pc-label">${'socialMediaPlan.brief.tone'.t()}</div>
                                <select class="form-control" :value="${x => x.creatorTone}" @change="${(x, c) => { x.creatorTone = c.event.target.value; }}">
                                    ${(0, fast_element_1.repeat)(x => x.toneOptions, (0, fast_element_1.html) `
                                    <option value="${t => t.label}">${t => t.label}</option>
                                    `)}
                                </select>
                            </div>
                            <div class="col-md-6 mb-2">
                                <div class="pc-label">${'socialMediaPlan.brief.contentType'.t()}</div>
                                <select class="form-control" :value="${x => x.creatorContentType}" @change="${(x, c) => { x.creatorContentType = c.event.target.value; }}">
                                    <option value="image">${'socialMediaPlan.brief.contentType.image'.t()}</option>
                                    <option value="carousel">${'socialMediaPlan.brief.contentType.carousel'.t()}</option>
                                    <option value="video">${'socialMediaPlan.brief.contentType.video'.t()}</option>
                                    <option value="story">${'socialMediaPlan.brief.contentType.story'.t()}</option>
                                    <option value="thread">${'socialMediaPlan.brief.contentType.thread'.t()}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="pc-card">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <div class="pc-label">${'socialMediaPlan.brief.audience'.t()}</div>
                                <select class="form-control" :value="${x => x.briefAudience}" @change="${(x, c) => { x.briefAudience = c.event.target.value; }}">
                                    ${(0, fast_element_1.repeat)(x => x.audienceOptions, (0, fast_element_1.html) `
                                        ${(a, c) => console.log(a.label, c.parent.briefAudience, c.parent.editingPostId)}
                                    <option ?selected="${(a, c) => a.label === c.parent.briefAudience}" value="${a => a.label}">${a => a.label}</option>
                                    `)}
                                </select>
                            </div>
                            <div class="col-md-6 mb-2">
                                <div class="pc-label">${'socialMediaPlan.brief.cta'.t()}</div>
                                <input class="form-control" :value="${x => x.briefCta}" @input="${(x, c) => { x.briefCta = c.event.target.value; }}" placeholder="${'socialMediaPlan.brief.ctaPlaceholder'.t()}">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="pc-card mb-3">
                        <div class="pc-label"><i class="iconsminds-globe-2"></i> ${'socialMediaPlan.brief.platforms'.t()}</div>
                        <div style="margin-top:8px">
                            ${(0, fast_element_1.repeat)(x => x.getPlatformOrder(), (0, fast_element_1.html) `
                            <span class="platform-chip ${(pid, c) => c.parent.isPlatformSelected(pid) ? 'selected' : ''} ${(pid, c) => !c.parent.isPlatformConnected(pid) ? 'disabled' : ''}"
                                style="${(pid, c) => !c.parent.isPlatformConnected(pid) ? 'opacity:0.45;cursor:not-allowed;' : ''}"
                                @click="${(pid, c) => c.parent.togglePlatform(pid)}"
                                title="${(pid, c) => !c.parent.isPlatformConnected(pid) ? 'socialMediaPlan.platformNotConnected.chipTitle'.t() : ''}">
                                <span :innerHTML="${(pid, c) => c.parent.pfBadgeHtml(pid, 26)}"></span>
                                <span class="chip-label">${(pid, c) => c.parent.getPlatformLabel(pid)}</span>
                            </span>
                            `)}
                        </div>
                        ${(0, fast_element_1.when)(x => Object.keys(x.socialMediaStatus).length > 0 && x.getPlatformOrder().some(pid => !x.isPlatformConnected(pid)), (0, fast_element_1.html) `
                        <div style="margin-top:8px;padding:8px 10px;background:#FDF3E3;border:1px solid #f5d6a0;border-radius:8px;font-size:.76rem;color:#B45309;display:flex;align-items:center;gap:6px;">
                            <i class="simple-icon-exclamation" style="flex-shrink:0;"></i>
                            <span>${'socialMediaPlan.platformNotConnected.chipHint'.t()} <a href="javascript:void(0)" style="color:#B45309;font-weight:700;text-decoration:underline;" @click="${x => x.goToSocialSettings()}">${'socialMediaPlan.platformNotConnected.goToSettings'.t()} →</a></span>
                        </div>
                        `)}
                        <div class="pc-hint">${'socialMediaPlan.brief.platformsHint'.t()}</div>
                    </div>
                    <div class="pc-card" style="background:var(--cs-primary-soft);border-color:var(--cs-primary-soft-border)">
                        <div class="pc-label" style="color:var(--cs-primary)"><i class="iconsminds-idea"></i> ${'socialMediaPlan.creator.tip2026Title'.t()}</div>
                        <div class="small text-muted">${'socialMediaPlan.creator.tip2026Text'.t()}</div>
                    </div>
                </div>
            </div>
        </div>
        `)}

        
        ${(0, fast_element_1.when)(x => x.creatorStep === 2, (0, fast_element_1.html) `
        <div class="cs-creator-step">
            ${(0, fast_element_1.when)(x => !x.generatedContentReady, (0, fast_element_1.html) `
            <div class="pc-card text-center py-5">
                <i class="iconsminds-magic-wand" style="font-size:2.4rem;color:var(--cs-primary);"></i>
                <h5 class="font-weight-bold mt-3">${'socialMediaPlan.creator.generate.title'.t()}</h5>
                <p class="text-muted small mb-4">${'socialMediaPlan.creator.generate.desc'.t()}</p>
                <button class="btn-generate" ?disabled="${x => x.generatingAI}" @click="${x => x.generateWithAI()}">
                    ${(0, fast_element_1.when)(x => x.generatingAI, (0, fast_element_1.html) `<app-loader block="true" width="14" height="14"></app-loader>`)}
                    <i class="iconsminds-flash-2"></i>
                    ${(0, fast_element_1.when)(x => x.generatingAI, (0, fast_element_1.html) `${'socialMediaPlan.creator.generating'.t()}`)}
                    ${(0, fast_element_1.when)(x => !x.generatingAI, (0, fast_element_1.html) `${'socialMediaPlan.creator.generateBtn'.t()}`)}
                </button>
                <button class="btn btn-outline-secondary ml-2" @click="${x => x.writeManually()}">
                    <i class="simple-icon-pencil"></i> ${'socialMediaPlan.creator.manually'.t()}
                </button>
            </div>
            `)}
            ${(0, fast_element_1.when)(x => x.generatedContentReady, (0, fast_element_1.html) `
            <div>
                ${(0, fast_element_1.when)(x => x.isVisualContentType(), (0, fast_element_1.html) `
                <div class="pc-card gen-img-card mb-3">
                    <div class="pc-label"><i class="iconsminds-photo"></i> ${'socialMediaPlan.creator.imageSection'.t()}</div>

                    ${(0, fast_element_1.when)(x => !x.uploadedImageUrl, (0, fast_element_1.html) `
                    <div class="mt-2">
                        <div class="pc-hint mb-2" style="font-size:.75rem;">${'socialMediaPlan.creator.imagePromptLabel'.t()}</div>
                        <div class="d-flex" style="gap:8px;align-items:center">
                            <input type="text" class="form-control flex-grow-1" :value="${x => x.imagePrompt}" @input="${(x, c) => { x.imagePrompt = c.event.target.value; }}" placeholder="${x => 'socialMediaPlan.creator.imagePromptPlaceholder'.t()}">
                            <button class="btn btn-primary d-inline-flex align-items-center" style="gap:6px;flex-shrink:0" ?disabled="${x => x.generatingImage}" @click="${x => x.generateImage()}">
                                ${(0, fast_element_1.when)(x => x.generatingImage, (0, fast_element_1.html) `<app-loader block="true" width="14" height="14"></app-loader>`)}
                                ${(0, fast_element_1.when)(x => !x.generatingImage, (0, fast_element_1.html) `<i class="iconsminds-photo"></i>`)}
                                ${'socialMediaPlan.creator.generateImage'.t()}
                            </button>
                        </div>
                        ${(0, fast_element_1.when)(x => !!x.generatedImageUrl, (0, fast_element_1.html) `
                        <div class="gen-img-preview mt-3">
                            <img src="${x => x.generatedImageUrl}" alt="Generated">
                            <span class="gen-img-badge"><i class="simple-icon-check"></i> AI</span>
                            <button class="btn btn-sm btn-outline-danger" style="position:absolute;top:6px;right:6px;" @click="${x => x.clearGeneratedImage()}" title="${'socialMediaPlan.creator.imageClear'.t()}"><i class="simple-icon-trash"></i></button>
                        </div>
                        `)}
                    </div>
                    `)}

                    ${(0, fast_element_1.when)(x => !x.generatedImageUrl, (0, fast_element_1.html) `
                    <div class="mt-2">
                        <div class="pc-hint mb-2" style="font-size:.75rem;">${'socialMediaPlan.creator.imageUploadLabel'.t()}</div>
                        <part-file-upload
                            name="image"
                            mode="file"
                            accept="image/*"
                            placeholder="socialMediaPlan.creator.imageChoose"
                            :uploadStarted="${x => x.uploadingImage}"
                            :onSelectFile="${x => (e) => x.handleImageFileSelect(e)}"
                        ></part-file-upload>
                        ${(0, fast_element_1.when)(x => !!x.uploadedImageUrl, (0, fast_element_1.html) `
                        <div class="gen-img-preview mt-2" style="position:relative;">
                            <img src="${x => x.uploadedImageUrl}" alt="Uploaded">
                            <span class="gen-img-badge"><i class="simple-icon-cloud-upload"></i></span>
                            <button class="btn btn-sm btn-outline-danger" style="position:absolute;top:6px;right:6px;" @click="${x => x.clearUploadedImage()}" title="${'socialMediaPlan.creator.imageClear'.t()}"><i class="simple-icon-trash"></i></button>
                        </div>
                        `)}
                    </div>
                    `)}
                </div>
                `)}


                <div class="pv-tabs">
                    ${(0, fast_element_1.repeat)(x => x.selectedPlatforms, (0, fast_element_1.html) `
                    <span class="pv-tab ${(pid, c) => c.parent.activePreviewPlatform === pid ? 'active' : ''}" @click="${(pid, c) => { c.parent.activePreviewPlatform = pid; }}">
                        <span :innerHTML="${(pid, c) => c.parent.pfBadgeHtml(pid, 18)}"></span>
                        ${(pid, c) => c.parent.getPlatformLabel(pid)}
                    </span>
                    `)}
                    <button class="btn btn-sm btn-outline-primary d-flex align-items-center ml-auto" @click="${x => x.generateWithAI()}" style="gap:6px">
                        <i class="simple-icon-refresh"></i> ${'socialMediaPlan.creator.regenerate'.t()}
                    </button>
                </div>
                ${(0, fast_element_1.repeat)(x => x.selectedPlatforms, (0, fast_element_1.html) `
                ${(0, fast_element_1.when)((pid, c) => c.parent.activePreviewPlatform === pid, (0, fast_element_1.html) `
                <div class="pv-pane active">
                    <div class="pv-preview-col">
                        <div class="native-preview">
                            <div class="np-header">
                                <div class="np-avatar">TM</div>
                                <div>
                                    <div class="np-name">${'socialMediaPlan.creator.brandName'.t()}</div>
                                    <div class="np-handle">${(pid, c) => c.parent.getPlatformLabel(pid)} &bull; ${'socialMediaPlan.creator.now'.t()}</div>
                                </div>
                                <span class="np-more">&#xB7;&#xB7;&#xB7;</span>
                            </div>
                            <div class="np-media">
                                ${(0, fast_element_1.when)((pid, c) => !!(c.parent.generatedImageUrl || c.parent.uploadedImageUrl), (0, fast_element_1.html) `<img src="${(pid, c) => c.parent.generatedImageUrl || c.parent.uploadedImageUrl}" alt="Preview">`)}
                                ${(0, fast_element_1.when)((pid, c) => !(c.parent.generatedImageUrl || c.parent.uploadedImageUrl), (0, fast_element_1.html) `<i class="iconsminds-photo"></i>`)}
                            </div>
                            <div class="np-caption">${(pid, c) => c.parent.getPreviewContent(pid).text}</div>
                            <div class="np-hashtags">${(pid, c) => (c.parent.getPreviewContent(pid).hashtags || []).join(' ')}</div>
                            <div class="np-footer">
                                <span><i class="simple-icon-heart"></i> ${'socialMediaPlan.creator.like'.t()}</span>
                                <span><i class="iconsminds-speach-bubbles"></i> ${'socialMediaPlan.creator.comment'.t()}</span>
                                <span><i class="simple-icon-share"></i> ${'socialMediaPlan.creator.share'.t()}</span>
                            </div>
                        </div>
                    </div>
                    <div class="pv-editor">
                        ${(0, fast_element_1.when)((pid, c) => !!(c.parent.generatedImageUrl || c.parent.uploadedImageUrl), (0, fast_element_1.html) `
                        <div class="gen-img-preview">
                            <img src="${(pid, c) => c.parent.generatedImageUrl || c.parent.uploadedImageUrl}" alt="Generated image">
                            <span class="gen-img-badge">${(pid, c) => c.parent.generatedImageUrl ? (0, fast_element_1.html) `<i class="simple-icon-check"></i> AI Image` : (0, fast_element_1.html) `<i class="simple-icon-cloud-upload"></i>`}</span>
                        </div>
                        `)}
                        ${(0, fast_element_1.when)((pid, c) => pid === 'facebook' && c.parent.fbPages.length >= 1, (0, fast_element_1.html) `
                        <div class="pv-field">
                            <div class="pv-field-header"><label>${'socialMediaPlan.creator.fbPageLabel'.t()}</label></div>
                            <div style="display:flex;flex-direction:column;gap:6px;margin-top:4px;">
                                ${(0, fast_element_1.repeat)((pid, c) => c.parent.fbPages, (0, fast_element_1.html) `
                                <label style="display:flex;align-items:center;gap:8px;font-size:.82rem;cursor:pointer;">
                                    <input type="radio" name="fb-page" :checked="${(page, c) => c.parentContext.parent.selectedFbPageId === page.id}" @change="${(page, c) => c.parentContext.parent.selectFbPage(page.id)}">
                                    ${page => page.name}
                                </label>
                                `)}
                            </div>
                        </div>
                        `)}
                        ${(0, fast_element_1.when)((pid, c) => pid === 'facebook' && !c.parent.loadingFbPages && c.parent.fbPages.length === 0, (0, fast_element_1.html) `
                        <div class="pv-field">
                            <div style="background:#FDF3E3;border:1px solid #f5d6a0;border-radius:8px;padding:10px 14px;font-size:.8rem;color:#B45309;display:flex;align-items:flex-start;gap:8px;">
                                <i class="simple-icon-exclamation" style="flex-shrink:0;margin-top:1px;"></i>
                                <span>${'socialMediaPlan.creator.fbNoPages'.t()}</span>
                            </div>
                        </div>
                        `)}
                        ${(0, fast_element_1.when)((pid, c) => pid === 'linkedin' && c.parent.liPages.length >= 1, (0, fast_element_1.html) `
                        <div class="pv-field">
                            <div class="pv-field-header"><label>${'socialMediaPlan.creator.liPageLabel'.t()}</label></div>
                            <div style="display:flex;flex-direction:column;gap:6px;margin-top:4px;">
                                ${(0, fast_element_1.repeat)((pid, c) => c.parent.liPages, (0, fast_element_1.html) `
                                <label style="display:flex;align-items:center;gap:8px;font-size:.82rem;cursor:pointer;">
                                    <input type="radio" name="li-page" :checked="${(page, c) => c.parentContext.parent.selectedLiPageId === page.id}" @change="${(page, c) => c.parentContext.parent.selectLiPage(page.id)}">
                                    ${page => page.name}
                                </label>
                                `)}
                            </div>
                        </div>
                        `)}
                        ${(0, fast_element_1.when)((pid, c) => pid === 'pinterest' && c.parent.ptBoards.length >= 1, (0, fast_element_1.html) `
                        <div class="pv-field">
                            <div class="pv-field-header"><label>${'socialMediaPlan.creator.ptBoardLabel'.t()}</label></div>
                            <div style="display:flex;flex-direction:column;gap:6px;margin-top:4px;">
                                ${(0, fast_element_1.repeat)((pid, c) => c.parent.ptBoards, (0, fast_element_1.html) `
                                <label style="display:flex;align-items:center;gap:8px;font-size:.82rem;cursor:pointer;">
                                    <input type="radio" name="pt-board" :checked="${(board, c) => c.parentContext.parent.selectedPtBoardId === board.id}" @change="${(board, c) => c.parentContext.parent.selectPtBoard(board.id)}">
                                    ${board => board.name}
                                </label>
                                `)}
                            </div>
                        </div>
                        `)}
                        ${(0, fast_element_1.when)((pid, c) => pid === 'pinterest' && !c.parent.loadingPtBoards && c.parent.ptBoards.length === 0, (0, fast_element_1.html) `
                        <div class="pv-field">
                            <div style="background:#FDF3E3;border:1px solid #f5d6a0;border-radius:8px;padding:10px 14px;font-size:.8rem;color:#B45309;display:flex;align-items:flex-start;gap:8px;">
                                <i class="simple-icon-exclamation" style="flex-shrink:0;margin-top:1px;"></i>
                                <span>${'socialMediaPlan.creator.ptNoBoards'.t()}</span>
                            </div>
                        </div>
                        `)}
                        <div class="pv-field">
                            <div class="pv-field-header">
                                <label>${'socialMediaPlan.creator.postContent'.t()}</label>
                                <span class="pv-counter">${(pid, c) => c.parent.getPreviewContent(pid).text.length} / ${(pid, c) => c.parent.getPlatformLimit(pid)}</span>
                            </div>
                            <textarea rows="7" @input="${(pid, c) => c.parent.updatePlatformText(pid, c.event)}" @paste="${(pid, c) => c.parent.handlePlatformTextPaste(pid, c.event)}">${(pid, c) => c.parent.getPreviewContent(pid).text}</textarea>
                            <div class="pv-limit-track"><div class="pv-limit-fill" style="width:${(pid, c) => c.parent.getCharFillPct(pid)}%"></div></div>
                        </div>
                        <div class="pv-field">
                            <div class="pv-field-header">
                                <label>${'socialMediaPlan.creator.hashtags'.t()}</label>
                                <span class="pv-field-meta">${'socialMediaPlan.creator.hashtagsHint'.t()}</span>
                            </div>
                            <input type="text" :value="${(pid, c) => (c.parent.getPreviewContent(pid).hashtags || []).join(' ')}" @input="${(pid, c) => c.parent.updatePlatformHashtags(pid, c.event)}" placeholder="#hashtag #kolejny">
                        </div>
                        <div class="pv-insight-card">
                            <div class="pv-insight-title"><i class="iconsminds-idea"></i> ${'socialMediaPlan.creator.aiInsightTitle'.t()}</div>
                            <div style="font-size:.8rem;color:#3A3F49">
                                ${'socialMediaPlan.creator.bestTime'.t()} <strong>${(pid, c) => c.parent.getPlatformBestTime(pid)}</strong><br>
                                ${'socialMediaPlan.creator.charLimit'.t()} <strong>${(pid, c) => c.parent.getPlatformLimit(pid)}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                `)}
                `)}
            </div>
            `)}
        </div>
        `)}

        
        ${(0, fast_element_1.when)(x => x.creatorStep === 3, (0, fast_element_1.html) `
        <div class="cs-creator-step">
            <div class="row">
                <div class="col-lg-7">
                    ${(0, fast_element_1.when)(x => x.finalAction !== 'published', (0, fast_element_1.html) `
                    <div class="pc-card mb-3">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <div class="pc-label"><i class="simple-icon-calendar"></i> ${'socialMediaPlan.schedule.date'.t()}</div>
                                <input type="date" class="form-control" :value="${x => x.scheduleDate}" @change="${(x, c) => { x.scheduleDate = c.event.target.value; }}">
                            </div>
                            <div class="col-md-6 mb-2">
                                <div class="pc-label"><i class="simple-icon-clock"></i> ${'socialMediaPlan.schedule.time'.t()}</div>
                                <input type="time" class="form-control" :value="${x => x.scheduleTime}" @change="${(x, c) => { x.scheduleTime = c.event.target.value; }}">
                            </div>
                        </div>
                    </div>
                    `)}
                    <div class="pc-card">
                        <div class="pc-label mb-2">${'socialMediaPlan.schedule.action'.t()}</div>
                        <div class="row">
                            ${(0, fast_element_1.repeat)(x => [['draft', 'iconsminds-save', 'socialMediaPlan.schedule.draftTitle', 'socialMediaPlan.schedule.draftDesc'], ['needs_review', 'iconsminds-security-check', 'socialMediaPlan.schedule.reviewTitle', 'socialMediaPlan.schedule.reviewDesc'], ['scheduled', 'simple-icon-calendar', 'socialMediaPlan.schedule.scheduledTitle', 'socialMediaPlan.schedule.scheduledDesc'], ['published', 'simple-icon-rocket', 'socialMediaPlan.schedule.publishedTitle', 'socialMediaPlan.schedule.publishedDesc']], (0, fast_element_1.html) `
                            <div class="col-6 col-md-3 mb-2">
                                <div class="schedule-choice ${(a, c) => c.parent.finalAction === a[0] ? 'selected' : ''}" @click="${(a, c) => { c.parent.finalAction = a[0]; }}">
                                    <i class="${a => a[1]}"></i>
                                    <div class="sc-title">${a => a[2].t()}</div>
                                    <div class="sc-desc">${a => a[3].t()}</div>
                                </div>
                            </div>
                            `)}
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="pc-card">
                        <div class="pc-label mb-2"><i class="iconsminds-preview"></i> ${'socialMediaPlan.schedule.summary'.t()}</div>
                        <div class="recap-row"><span>${'socialMediaPlan.brief.topic'.t()}</span><strong>${x => x.briefTopic || '-'}</strong></div>
                        <div class="recap-row"><span>${'socialMediaPlan.brief.goal'.t()}</span><strong>${x => x.getGoalLabel(x.creatorGoal)}</strong></div>
                        <div class="recap-row"><span>${'socialMediaPlan.schedule.type'.t()}</span><strong>${x => x.creatorContentType}</strong></div>
                        <div class="recap-row"><span>${'socialMediaPlan.schedule.platforms'.t()}</span><strong>${x => x.selectedPlatforms.map(p => x.getPlatformLabel(p)).join(', ')}</strong></div>
                    </div>
                </div>
            </div>
        </div>
        `)}

    </div>

    <div class="cs-creator-footer">
        <button class="btn-cs-outline" style="${x => x.creatorStep === 1 ? 'visibility:hidden' : ''}" @click="${x => x.goToStep(x.creatorStep - 1)}">
            <i class="simple-icon-arrow-left"></i> ${'socialMediaPlan.back'.t()}
        </button>
        <div class="cs-creator-footer-right">
            <button class="btn-cs-outline" @click="${x => x.close()}">${'socialMediaPlan.cancel'.t()}</button>
            ${(0, fast_element_1.when)(x => x.creatorStep < 3, (0, fast_element_1.html) `
            <button class="btn-cs-primary" ?disabled="${x => (x.creatorStep === 1 && x.selectedPlatforms.length === 0) || x.uploadingVideo}" @click="${x => x.goToStep(x.creatorStep + 1)}">
                ${(0, fast_element_1.when)(x => x.uploadingVideo, (0, fast_element_1.html) `<app-loader block="true" width="14" height="14"></app-loader>`)}
                ${'socialMediaPlan.next'.t()} <i class="simple-icon-arrow-right"></i>
            </button>
            `)}
            ${(0, fast_element_1.when)(x => x.creatorStep === 3, (0, fast_element_1.html) `
            <button class="btn-cs-primary" ?disabled="${x => x.savingPost}" @click="${x => x.savePost()}">
                ${(0, fast_element_1.when)(x => x.savingPost, (0, fast_element_1.html) `<app-loader block="true" width="14" height="14"></app-loader>`)}
                <i class="simple-icon-check"></i> ${'socialMediaPlan.save'.t()}
            </button>
            `)}
        </div>
    </div>

</div>
`)}
`;
require("./styles/layout.scss");
const styles = T.css `@charset "UTF-8";
.cs-card {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(24, 24, 56, 0.06);
}

.btn-cs-primary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #5B3DF6;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.12s;
}
.btn-cs-primary:hover {
  opacity: 0.92;
}
.btn-cs-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-cs-outline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #3A3F49;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s;
}
.btn-cs-outline:hover {
  background: #EFF1F4;
}

.btn-cs-danger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #DC2626;
  border: 1px solid #f3c8c8;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}
.btn-cs-danger:hover {
  background: #FDEAEA;
}

.btn-cs-publish {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #16A34A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}
.btn-cs-publish:hover {
  opacity: 0.9;
}
.btn-cs-publish:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cs-badge {
  font-size: 0.7rem;
  font-weight: 700;
  background: #EFF1F4;
  color: #6B7180;
  border-radius: 20px;
  padding: 2px 8px;
}

.cs-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.cs-page-header h2 {
  font-size: 1.25rem;
  font-weight: 800;
  margin: 0 0 4px;
}
.cs-page-header .cs-label-primary {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5B3DF6;
  margin-bottom: 2px;
}
.cs-page-header .cs-desc {
  font-size: 0.84rem;
  color: #6B7180;
  max-width: 560px;
  margin: 0;
}

.cs-stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}

.cs-stat-card {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cs-stat-card .cs-stat-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #6B7180;
}
.cs-stat-card .cs-stat-value {
  font-size: 1.6rem;
  font-weight: 800;
  color: #16181D;
}
.cs-stat-card .cs-stat-value.warn {
  color: #B45309;
}
.cs-stat-card .cs-stat-value.success {
  color: #16A34A;
}

.cs-studio-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #EFF1F4;
  margin-bottom: 16px;
}
.cs-studio-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 18px;
  font-size: 0.86rem;
  font-weight: 700;
  color: #9199A8;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}
.cs-studio-tabs button:hover {
  color: #3A3F49;
}
.cs-studio-tabs button.active {
  color: #5B3DF6;
  border-bottom-color: #5B3DF6;
}

.cs-library-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.cs-library-header .cs-library-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
}

.cs-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
.cs-filters .cs-search-wrap {
  position: relative;
  flex: 1 1 200px;
}
.cs-filters .cs-search-wrap i {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #9199A8;
  font-size: 0.8rem;
}
.cs-filters .cs-search-wrap input {
  width: 100%;
  padding: 7px 10px 7px 30px;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  font-size: 0.82rem;
}
.cs-filters .cs-filter-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.cs-filters .cs-filter-btns button {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 999px;
  padding: 5px 14px;
  font-size: 0.74rem;
  font-weight: 600;
  color: #6B7180;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.cs-filters .cs-filter-btns button:hover {
  background: #EFF1F4;
}
.cs-filters .cs-filter-btns button.active {
  background: #F1EEFF;
  color: #5B3DF6;
  border-color: #E1D9FF;
}

.cs-posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
}

.cs-post-card {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 14px;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.12s;
}
.cs-post-card:hover {
  box-shadow: 0 10px 28px rgba(24, 24, 56, 0.1);
  border-color: #C4C9D2;
  transform: translateY(-2px);
}
.cs-post-card .cs-post-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 4px;
}
.cs-post-card .cs-post-title {
  font-weight: 700;
  font-size: 0.88rem;
  margin-bottom: 4px;
  color: #16181D;
}
.cs-post-card .cs-post-excerpt {
  font-size: 0.76rem;
  color: #6B7180;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 32px;
  margin-bottom: 10px;
}
.cs-post-card .cs-post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cs-post-card .cs-post-date {
  font-size: 0.7rem;
  color: #9199A8;
}
.cs-post-card .cs-post-actions {
  display: flex;
  gap: 4px;
}
.cs-post-card .cs-post-actions button {
  background: none;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 3px 7px;
  font-size: 0.7rem;
  cursor: pointer;
  color: #6B7180;
  transition: background 0.1s;
}
.cs-post-card .cs-post-actions button:hover {
  background: #EFF1F4;
}
.cs-post-card .cs-post-actions button.danger {
  color: #DC2626;
  border-color: #f3c8c8;
}
.cs-post-card .cs-post-actions button.danger:hover {
  background: #FDEAEA;
}

.cs-platform-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}

.cs-platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 6px 6px 0;
}
.cs-platform-chip:hover {
  border-color: #C4C9D2;
}
.cs-platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}

.cs-empty {
  text-align: center;
  padding: 48px 20px;
}
.cs-empty .cs-empty-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #F1EEFF;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 1.4rem;
}
.cs-empty strong {
  display: block;
  font-size: 1rem;
  color: #22252C;
  margin-bottom: 6px;
}
.cs-empty p {
  font-size: 0.82rem;
  color: #6B7180;
  max-width: 360px;
  margin: 0 auto 14px;
}

.cs-ai-assistant {
  background: linear-gradient(135deg, #F1EEFF 0%, #fff 100%);
  border-color: #E1D9FF;
}
.cs-ai-assistant .cs-ai-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}
.cs-ai-assistant .cs-ai-header .cs-ai-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #F1EEFF;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  flex-shrink: 0;
}
.cs-ai-assistant .cs-ai-header strong {
  font-size: 0.94rem;
  font-weight: 700;
}
.cs-ai-assistant .cs-ai-header p {
  font-size: 0.78rem;
  color: #6B7180;
  margin: 2px 0 0;
}
.cs-ai-assistant .cs-ai-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 12px;
}
.cs-ai-assistant .cs-ai-presets button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #E1D9FF;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 0.76rem;
  font-weight: 600;
  color: #5B3DF6;
  cursor: pointer;
  transition: background 0.12s;
}
.cs-ai-assistant .cs-ai-presets button:hover {
  background: #F1EEFF;
}
.cs-ai-assistant .cs-ai-input-row {
  display: flex;
  gap: 8px;
}
.cs-ai-assistant .cs-ai-input-row input {
  flex: 1;
  border: 1px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.84rem;
}
.cs-ai-assistant .cs-ai-response {
  background: #fff;
  border: 1px solid #E2E5EA;
  border-radius: 12px;
  margin-top: 14px;
  box-shadow: 0 10px 28px rgba(24, 24, 56, 0.1);
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #EFF1F4;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header span {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #5B3DF6;
  display: flex;
  align-items: center;
  gap: 7px;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-header button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: #9199A8;
}
.cs-ai-assistant .cs-ai-response .cs-ai-response-text {
  padding: 14px;
  font-size: 0.84rem;
  white-space: pre-wrap;
  color: #22252C;
  min-height: 40px;
}

.cs-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 16, 24, 0.4);
  z-index: 200;
}

.cs-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 440px;
  height: 100vh;
  background: #fff;
  box-shadow: var(--cs-shadow-lg);
  z-index: 210;
  display: flex;
  flex-direction: column;
}
@media (max-width: 500px) {
  .cs-drawer {
    width: 100vw;
  }
}
.cs-drawer .cs-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #EFF1F4;
}
.cs-drawer .cs-drawer-header h5 {
  margin: 0 0 4px;
  font-size: 0.96rem;
  font-weight: 700;
}
.cs-drawer .cs-drawer-header button {
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  color: #9199A8;
}
.cs-drawer .cs-drawer-tabs {
  display: flex;
  border-bottom: 1px solid #EFF1F4;
}
.cs-drawer .cs-drawer-tabs button {
  flex: 1;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 14px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #9199A8;
  cursor: pointer;
  transition: color 0.12s, border-color 0.12s;
}
.cs-drawer .cs-drawer-tabs button.active {
  color: #5B3DF6;
  border-bottom-color: #5B3DF6;
}
.cs-drawer .cs-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 16px;
}
.cs-drawer .cs-drawer-meta {
  background: #EFF1F4;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}
.cs-drawer .cs-drawer-meta div {
  text-align: center;
}
.cs-drawer .cs-drawer-meta span {
  display: block;
  font-size: 0.68rem;
  color: #6B7180;
  margin-bottom: 2px;
}
.cs-drawer .cs-drawer-meta strong {
  font-size: 0.78rem;
}
.cs-drawer .cs-platform-preview {
  margin-bottom: 12px;
}
.cs-drawer .cs-pf-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.cs-drawer .cs-pf-text {
  font-size: 0.82rem;
  color: #3A3F49;
  white-space: pre-wrap;
  padding: 8px;
  background: #EFF1F4;
  border-radius: 8px;
}
.cs-drawer .cs-pf-hashtags {
  font-size: 0.76rem;
  color: #2563EB;
  margin-top: 4px;
}
.cs-drawer .cs-best-time {
  display: flex;
  gap: 8px;
  font-size: 0.82rem;
  margin-bottom: 8px;
}
.cs-drawer .cs-drawer-footer {
  border-top: 1px solid #EFF1F4;
  padding: 10px 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cs-creator-overlay {
  position: fixed;
  inset: 0;
  background: #F6F6FA;
  z-index: 300;
  display: flex;
  flex-direction: column;
}

.cs-creator-topbar {
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #EFF1F4;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.cs-creator-topbar .cs-creator-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cs-creator-topbar .cs-creator-title .cs-creator-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(135deg, #5B3DF6, #8B6FF8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
.cs-creator-topbar .cs-creator-title strong {
  font-size: 0.96rem;
  font-weight: 700;
}
.cs-creator-topbar .cs-creator-title small {
  display: block;
  font-size: 0.72rem;
  color: #9199A8;
}
.cs-creator-topbar .cs-creator-steps {
  display: flex;
  align-items: center;
}

.cs-creator-body {
  flex: 1;
  overflow-y: auto;
  padding: 28px 20px 40px;
}

.cs-creator-step {
  max-width: 1100px;
  margin: 0 auto;
}

.cs-creator-footer {
  flex-shrink: 0;
  background: #fff;
  border-top: 1px solid #EFF1F4;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cs-creator-footer .cs-creator-footer-right {
  display: flex;
  gap: 10px;
}

.cs-field-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #3A3F49;
  margin-bottom: 6px;
}
.cs-field-label.tip {
  color: #5B3DF6;
}

.cs-generate-gate {
  text-align: center;
  padding: 48px 20px;
}
.cs-generate-gate i {
  font-size: 2.4rem;
  color: #5B3DF6;
}
.cs-generate-gate h5 {
  font-weight: 700;
  margin: 14px 0 6px;
}
.cs-generate-gate p {
  font-size: 0.82rem;
  color: #6B7180;
  margin-bottom: 18px;
}

.cs-preview-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-bottom: 16px;
}
.cs-preview-tabs button {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  background: #fff;
  padding: 7px 13px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6B7180;
  cursor: pointer;
  transition: all 0.12s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.cs-preview-tabs button.active {
  border-color: #5B3DF6;
  background: #F1EEFF;
  color: #5B3DF6;
}

.cs-platform-editor {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  align-items: flex-start;
}
@media (max-width: 768px) {
  .cs-platform-editor {
    grid-template-columns: 1fr;
  }
}

.cs-platform-editor-form label {
  display: block;
  margin-bottom: 6px;
}
.cs-platform-editor-form textarea {
  width: 100%;
}

.cs-image-gen-card {
  border-color: #E1D9FF !important;
  background: #F1EEFF !important;
}

.cs-generated-image {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E5EA;
}
.cs-generated-image img {
  display: block;
  width: 100%;
  max-height: 340px;
  object-fit: cover;
}

.cs-goal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

.cs-goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.cs-goal-card:hover {
  border-color: #C4C9D2;
  background: rgba(91, 61, 246, 0.04);
}
.cs-goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.cs-goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
  display: block;
}
.cs-goal-card span {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 6px;
}

.cs-tip-card {
  background: #F1EEFF !important;
  border-color: #E1D9FF !important;
}
.cs-tip-card p {
  font-size: 0.78rem;
  color: #6B7180;
  margin: 0;
}

.cs-action-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 10px;
  margin-top: 8px;
}

.cs-recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.cs-recap-row:last-child {
  border-bottom: none;
}
.cs-recap-row span {
  color: #6B7180;
  white-space: nowrap;
  flex-shrink: 0;
  padding-right: 8px;
}
.cs-recap-row strong {
  text-align: right;
  word-break: break-word;
}

.cs-calendar-section, .cs-history-section {
  min-height: 300px;
}

.cs-log-line {
  font-size: 0.8rem;
  font-family: "Courier New", monospace;
  padding: 2px 0;
  color: #1a6fa8;
}

.btn-generate app-loader, .btn-cs-primary app-loader, .btn-cs-outline app-loader, .btn-cs-publish app-loader, .btn-cs-danger app-loader {
  position: static !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  width: 14px !important;
  height: 14px !important;
}

.pc-card {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 20px;
}

.pc-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #3A3F49;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pc-hint {
  font-size: 0.72rem;
  color: #9199A8;
  margin-top: 4px;
}

.btn-generate {
  background: linear-gradient(135deg, #5B3DF6, #8B6FF8);
  border: none;
  color: #fff;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 8px;
  font-size: 0.95rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 8px 20px rgba(91, 61, 246, 0.28);
  transition: transform 0.12s, box-shadow 0.12s;
}
.btn-generate:hover {
  color: #fff;
  opacity: 0.96;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(91, 61, 246, 0.34);
}
.btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.platform-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 7px 14px 7px 8px;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s;
  background: #fff;
  margin: 0 8px 8px 0;
}
.platform-chip:hover {
  border-color: #C4C9D2;
}
.platform-chip.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.platform-chip .chip-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #22252C;
}

.goal-card {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.goal-card:hover {
  border-color: #C4C9D2;
}
.goal-card.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.goal-card i {
  font-size: 1.2rem;
  color: #5B3DF6;
  display: block;
}
.goal-card .goal-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #22252C;
  margin-top: 4px;
}

.native-preview {
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.09);
  background: #fff;
  box-shadow: 0 8px 32px rgba(24, 24, 56, 0.13), 0 1px 3px rgba(0, 0, 0, 0.06);
  max-width: 320px;
}

.np-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #fafafa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.np-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5B3DF6 0%, #8B6FF8 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.72rem;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(91, 61, 246, 0.35);
}

.np-name {
  font-size: 0.8rem;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
}

.np-handle {
  font-size: 0.68rem;
  color: #9199A8;
  line-height: 1.2;
}

.np-more {
  margin-left: auto;
  color: #C4C9D2;
  font-size: 1.1rem;
  line-height: 1;
}

.np-media {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  color: #C4C9D2;
  font-size: 0.72rem;
  min-height: 180px;
  background: repeating-linear-gradient(135deg, #f5f6f8 0px, #f5f6f8 10px, #eceef1 10px, #eceef1 20px);
}
.np-media i {
  font-size: 2rem;
  opacity: 0.5;
}
.np-media img {
  width: 100%;
  display: block;
  max-height: 260px;
  object-fit: cover;
}

.np-caption {
  padding: 12px 14px 6px;
  font-size: 0.82rem;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  color: #1a1d23;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.np-hashtags {
  padding: 0 14px 12px;
  font-size: 0.76rem;
  color: #4267b2;
  font-weight: 500;
  line-height: 1.5;
}

.np-footer {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  color: #6B7180;
}
.np-footer span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: color 0.12s;
}
.np-footer span:hover {
  color: #5B3DF6;
}

.pv-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: 2px solid #EFF1F4;
}

.pv-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1.5px solid #E2E5EA;
  border-radius: 999px;
  padding: 6px 14px 6px 8px;
  cursor: pointer;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6B7180;
  transition: all 0.15s;
}
.pv-tab:hover {
  border-color: #C4C9D2;
  background: #EFF1F4;
}
.pv-tab.active {
  border-color: #5B3DF6;
  background: #F1EEFF;
  color: #5B3DF6;
  box-shadow: 0 0 0 3px rgba(91, 61, 246, 0.1);
}
.pv-tab .pv-tab-warn {
  color: #DC2626;
  margin-left: 2px;
}

.pv-pane {
  display: none;
}

.pv-pane.active {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 28px;
  align-items: flex-start;
}
@media (max-width: 900px) {
  .pv-pane.active {
    grid-template-columns: 1fr;
  }
}

.pv-preview-col {
  position: sticky;
  top: 16px;
}

.pv-editor {
  background: #fff;
  border: 1px solid #EFF1F4;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.pv-editor .pv-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.pv-editor .pv-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pv-editor .pv-field-header label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #3A3F49;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.pv-editor .pv-field-header .pv-field-meta {
  font-size: 0.7rem;
  color: #9199A8;
}
.pv-editor textarea {
  font-size: 0.88rem;
  line-height: 1.7;
  color: #16181D;
  width: 100%;
  resize: vertical;
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 12px 14px;
  min-height: 130px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pv-editor textarea:focus {
  border-color: #5B3DF6;
  box-shadow: 0 0 0 3px #F1EEFF;
  outline: none;
}
.pv-editor input[type=text] {
  font-size: 0.84rem;
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 8px 12px;
  width: 100%;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pv-editor input[type=text]:focus {
  border-color: #5B3DF6;
  box-shadow: 0 0 0 3px #F1EEFF;
  outline: none;
}
.pv-editor .pv-hashtag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 2px;
}
.pv-editor .pv-hashtag-chips span {
  display: inline-block;
  background: #EAF1FE;
  color: #2563EB;
  font-size: 0.73rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 10px;
}

.pv-counter {
  font-size: 0.72rem;
  color: #9199A8;
  text-align: right;
}
.pv-counter.over {
  color: #DC2626;
  font-weight: 700;
}

.pv-limit-track {
  height: 4px;
  border-radius: 4px;
  background: #EFF1F4;
  overflow: hidden;
}

.pv-limit-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.2s, background 0.2s;
  background: #16A34A;
}
.pv-limit-fill.warn {
  background: #B45309;
}
.pv-limit-fill.over {
  background: #DC2626;
}

.pv-insight-card {
  background: linear-gradient(135deg, #F1EEFF, #fff);
  border: 1px solid #E1D9FF;
  border-radius: 8px;
  padding: 12px 14px;
}

.pv-insight-title {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 800;
  color: #5B3DF6;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.gen-img-card {
  border-color: #E1D9FF !important;
  background: #F1EEFF !important;
}

.gen-img-preview {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E2E5EA;
  background: #EFF1F4;
  position: relative;
  line-height: 0;
}
.gen-img-preview img {
  display: block;
  width: 100%;
  max-height: 220px;
  object-fit: cover;
}
.gen-img-preview .gen-img-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 0.64rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 9px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  backdrop-filter: blur(4px);
}

.engagement-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 10px;
}

.engagement-Wysoki {
  background: #E9F9EF;
  color: #16A34A;
}

.engagement-Średni {
  background: #FDF3E3;
  color: #B45309;
}

.engagement-Niski {
  background: #FDEAEA;
  color: #DC2626;
}

.schedule-choice {
  border: 1.5px solid #E2E5EA;
  border-radius: 8px;
  padding: 14px;
  cursor: pointer;
  transition: all 0.15s;
  height: 100%;
}
.schedule-choice:hover {
  border-color: #C4C9D2;
}
.schedule-choice.selected {
  border-color: #5B3DF6;
  background: #F1EEFF;
}
.schedule-choice i {
  font-size: 1.25rem;
  color: #5B3DF6;
  display: block;
}
.schedule-choice .sc-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #22252C;
  margin: 6px 0 2px;
}
.schedule-choice .sc-desc {
  font-size: 0.7rem;
  color: #9199A8;
}

.recap-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed #EFF1F4;
  font-size: 0.8rem;
}
.recap-row:last-child {
  border-bottom: none;
}
.recap-row span {
  color: #6B7180;
}
.recap-row strong {
  text-align: right;
}

.pf-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  flex-shrink: 0;
  border-radius: 50%;
  line-height: 1;
}
.pf-badge.pf-facebook {
  background: #1877F2;
}
.pf-badge.pf-instagram {
  background: linear-gradient(135deg, #f9ce34, #ee2a7b, #6228d7);
}
.pf-badge.pf-x {
  background: #000;
}
.pf-badge.pf-linkedin {
  background: #0A66C2;
}
.pf-badge.pf-tiktok {
  background: linear-gradient(135deg, #25F4EE, #111 45%, #FE2C55);
}
.pf-badge.pf-youtube {
  background: #FF0000;
}
.pf-badge.pf-threads {
  background: #000;
}
.pf-badge.pf-pinterest {
  background: #E60023;
}

.pf-row {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}`;
const shadowOptions = { "mode": "open" };
let SmCreatorWizard = class SmCreatorWizard extends client_1.RWSViewComponent {
    constructor(popupService, wsService, routeSearchService) {
        super();
        this.popupService = popupService;
        this.wsService = wsService;
        this.routeSearchService = routeSearchService;
        // Input props (set by parent via :property binding)
        this.creatorOpen = false;
        this.editingPost = null;
        this.proxy = false;
        // Internal form state
        this.creatorStep = 1;
        this.editingPostId = null;
        this.briefTopic = '';
        this.briefAudience = '';
        this.briefCta = '';
        this.briefKeywords = '';
        this.creatorGoal = 'sprzedaz';
        this.creatorTone = 'friendly';
        this.creatorContentType = 'image';
        this.selectedPlatforms = ['instagram', 'facebook'];
        this.generatedContent = {};
        this.generatingAI = false;
        this.generatedContentReady = false;
        this.activePreviewPlatform = '';
        this.finalAction = 'scheduled';
        this.scheduleDate = '';
        this.scheduleTime = '10:00';
        this.savingPost = false;
        this.imagePrompt = '';
        this.generatedImageUrl = '';
        this.generatedImageFileId = '';
        this.generatingImage = false;
        this.uploadedImageUrl = '';
        this.uploadedImageFileId = '';
        this.uploadingImage = false;
        this.videoFileUrl = '';
        this.videoFileId = '';
        this.uploadingVideo = false;
        this.videoUploadProgress = 0;
        this.pendingVideoFile = null;
        this.publishingVideoProgress = 0;
        this.publishingVideoPlatform = '';
        this.wsid = '';
        this._wsProgressUnsub = null;
        this.fbPages = [];
        this.selectedFbPageId = '';
        this.loadingFbPages = false;
        this.liPages = [];
        this.selectedLiPageId = '';
        this.loadingLiPages = false;
        this.ptBoards = [];
        this.selectedPtBoardId = '';
        this.loadingPtBoards = false;
        this.socialMediaStatus = {};
        this.toneOptions = [];
        this.goalOptions = [];
        this.audienceOptions = [];
        this.PLATFORM_STATUS_KEY = {
            facebook: 'fb', instagram: 'ig', youtube: 'youtube',
            tiktok: 'tiktok', x: 'x', linkedin: 'linkedin',
            pinterest: 'pinterest', threads: 'threads',
        };
    }
    editingPostChanged() {
        if (this.editingPost)
            this.fillFromPost(this.editingPost);
    }
    creatorOpenChanged() {
        var _a, _b;
        if (this.creatorOpen && !this.editingPost)
            this.resetForm();
        if (this.creatorOpen && this.editingPost)
            this.fillFromPost(this.editingPost);
        if (this.creatorOpen) {
            this.loadSocialMediaStatus();
            this.loadDictionaries();
            this.wsid = crypto.randomUUID();
            this.publishingVideoProgress = 0;
            this.publishingVideoPlatform = '';
            (_a = this._wsProgressUnsub) === null || _a === void 0 ? void 0 : _a.call(this);
            this._wsProgressUnsub = this.wsService.listenForMessage('status_update', (msg) => {
                var _a, _b, _c, _d;
                const payload = msg === null || msg === void 0 ? void 0 : msg.data;
                if ((payload === null || payload === void 0 ? void 0 : payload.key) !== this.wsid)
                    return;
                this.publishingVideoProgress = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.value) === null || _a === void 0 ? void 0 : _a.progress) !== null && _b !== void 0 ? _b : 0;
                this.publishingVideoPlatform = (_d = (_c = payload === null || payload === void 0 ? void 0 : payload.value) === null || _c === void 0 ? void 0 : _c.platform) !== null && _d !== void 0 ? _d : '';
            }, 'social_video_upload_progress');
        }
        if (!this.creatorOpen) {
            (_b = this._wsProgressUnsub) === null || _b === void 0 ? void 0 : _b.call(this);
            this._wsProgressUnsub = null;
        }
    }
    resetForm() {
        var _a, _b, _c;
        this.editingPostId = null;
        this.briefTopic = '';
        this.briefAudience = ((_a = this.audienceOptions[0]) === null || _a === void 0 ? void 0 : _a.label) || '';
        this.briefCta = '';
        this.briefKeywords = '';
        this.creatorGoal = ((_b = this.goalOptions[0]) === null || _b === void 0 ? void 0 : _b.label) || '';
        this.creatorTone = ((_c = this.toneOptions[0]) === null || _c === void 0 ? void 0 : _c.label) || '';
        this.creatorContentType = 'image';
        this.selectedPlatforms = [];
        this.generatedContent = {};
        this.generatedContentReady = false;
        this.finalAction = 'scheduled';
        this.scheduleDate = '';
        this.scheduleTime = '10:00';
        this.imagePrompt = '';
        this.generatedImageUrl = '';
        this.generatedImageFileId = '';
        this.uploadedImageUrl = '';
        this.uploadedImageFileId = '';
        this.videoFileUrl = '';
        this.videoFileId = '';
        this.pendingVideoFile = null;
        this.fbPages = [];
        this.selectedFbPageId = '';
        this.liPages = [];
        this.selectedLiPageId = '';
        this.ptBoards = [];
        this.selectedPtBoardId = '';
        this.creatorStep = 1;
        this.activePreviewPlatform = 'instagram';
    }
    fillFromPost(post) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.editingPostId = String(post.id);
        this.briefTopic = ((_a = post.brief) === null || _a === void 0 ? void 0 : _a.topic) || '';
        this.briefAudience = ((_b = post.brief) === null || _b === void 0 ? void 0 : _b.audience) || '';
        this.briefCta = ((_c = post.brief) === null || _c === void 0 ? void 0 : _c.cta) || '';
        this.briefKeywords = ((_d = post.brief) === null || _d === void 0 ? void 0 : _d.keywords) || '';
        this.creatorGoal = ((_e = post.brief) === null || _e === void 0 ? void 0 : _e.goal) || '';
        this.creatorTone = ((_f = post.brief) === null || _f === void 0 ? void 0 : _f.tone) || '';
        this.creatorContentType = ((_g = post.brief) === null || _g === void 0 ? void 0 : _g.contentType) || 'image';
        this.selectedPlatforms = [...(post.platforms || [])];
        this.generatedContent = { ...(post.content || {}) };
        this.generatedContentReady = Object.keys(this.generatedContent).length > 0;
        this.finalAction = post.scheduledAt ? 'scheduled' : 'draft';
        if (post.scheduledAt) {
            const d = new Date(post.scheduledAt);
            this.scheduleDate = d.toISOString().split('T')[0];
            this.scheduleTime = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        }
        this.imagePrompt = ((_h = post.brief) === null || _h === void 0 ? void 0 : _h.imagePrompt) || '';
        const firstContent = (_j = post.content) === null || _j === void 0 ? void 0 : _j[(_k = post.platforms) === null || _k === void 0 ? void 0 : _k[0]];
        this.generatedImageUrl = (firstContent === null || firstContent === void 0 ? void 0 : firstContent.imageFileUrl) || '';
        this.generatedImageFileId = (firstContent === null || firstContent === void 0 ? void 0 : firstContent.imageFileId) || '';
        this.uploadedImageUrl = '';
        this.uploadedImageFileId = '';
        this.videoFileUrl = (firstContent === null || firstContent === void 0 ? void 0 : firstContent.videoUrl) || '';
        this.videoFileId = (firstContent === null || firstContent === void 0 ? void 0 : firstContent.videoFileId) || '';
        this.creatorStep = 1;
        this.activePreviewPlatform = this.selectedPlatforms[0] || '';
    }
    close() { this.$emit('wizard-closed', {}); }
    goToStep(step) {
        if (step === 2 && !this.selectedPlatforms.length) {
            this.notifyService.notify('socialMediaPlan.creator.selectPlatform'.t(), 'warning');
            return;
        }
        if (step === 2) {
            this.checkPlatformConnections().then(ok => {
                if (!ok)
                    return;
                this.creatorStep = 2;
                this.activePreviewPlatform = this.selectedPlatforms[0] || '';
                if (this.selectedPlatforms.includes('facebook'))
                    this.loadFbPages();
                if (this.selectedPlatforms.includes('linkedin'))
                    this.loadLiPages();
                if (this.selectedPlatforms.includes('pinterest'))
                    this.loadPtBoards();
            });
            return;
        }
        if (step === 3 && this.pendingVideoFile && this.needsVideoUpload()) {
            // Just navigate — upload will happen when Save is clicked
        }
        this.creatorStep = step;
    }
    async uploadPendingVideo() {
        const file = this.pendingVideoFile;
        if (!file)
            return;
        this.uploadingVideo = true;
        this.videoUploadProgress = 0;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackendUpload('social-media-post.upload-video', undefined, file, undefined, (progress) => { this.videoUploadProgress = progress; })
                : await this.apiService.back.uploadFiles('social-media-post.upload-video', { video: file }, {}, {
                    method: 'POST',
                    onProgress: (progress) => { this.videoUploadProgress = progress; },
                });
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && resp.data) {
                this.videoFileUrl = resp.data.fileUrl;
                this.videoFileId = resp.data.fileId;
                this.pendingVideoFile = null;
                this.videoUploadProgress = 100;
            }
            else {
                this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.creator.videoError'.t(), 'error');
            }
        }
        catch (_a) {
            this.notifyService.notify('socialMediaPlan.creator.videoError'.t(), 'error');
        }
        finally {
            this.uploadingVideo = false;
        }
    }
    isPlatformConnected(pid) {
        var _a, _b;
        const key = this.PLATFORM_STATUS_KEY[pid] || pid;
        return (_b = (_a = this.socialMediaStatus[key]) === null || _a === void 0 ? void 0 : _a.connected) !== null && _b !== void 0 ? _b : true;
    }
    hasDisconnectedPlatforms() {
        return this.selectedPlatforms.some(pid => !this.isPlatformConnected(pid));
    }
    goToSocialSettings() {
        this.close();
        component_1.SiteMenu.goto.bind(this)('/settings/general#social-media');
    }
    async loadSocialMediaStatus() {
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('settings.social-media.status', undefined, undefined, 'GET')
                : await this.apiService.back.get('settings.social-media.status');
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && resp.data)
                this.socialMediaStatus = resp.data;
        }
        catch ( /* silent */_a) { /* silent */ }
    }
    async checkPlatformConnections() {
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('settings.social-media.status', undefined, undefined, 'GET')
                : await this.apiService.back.get('settings.social-media.status');
            if (!(resp === null || resp === void 0 ? void 0 : resp.success) || !resp.data)
                return true;
            const disconnected = this.selectedPlatforms.filter(pid => {
                var _a;
                const key = this.PLATFORM_STATUS_KEY[pid] || pid;
                return !((_a = resp.data[key]) === null || _a === void 0 ? void 0 : _a.connected);
            });
            if (disconnected.length === 0)
                return true;
            const names = disconnected.map(pid => { var _a; return ((_a = _shared_1.PLATFORM_META[pid]) === null || _a === void 0 ? void 0 : _a.label) || pid; }).join(', ');
            await this.popupService.firePopup({
                title: 'socialMediaPlan.platformNotConnected.title'.t(),
                html: `${'socialMediaPlan.platformNotConnected.message'.t()}<br><br><strong>${names}</strong><br><br>${'socialMediaPlan.platformNotConnected.hint'.t()}`,
                icon: 'warning',
                confirmButtonText: 'popup.ok'.t(),
            });
            return false;
        }
        catch (_a) {
            return true;
        }
    }
    togglePlatform(pid) {
        if (!this.isPlatformConnected(pid))
            return;
        this.selectedPlatforms = this.selectedPlatforms.includes(pid)
            ? this.selectedPlatforms.filter(p => p !== pid)
            : [...this.selectedPlatforms, pid];
    }
    isPlatformSelected(pid) { return this.selectedPlatforms.includes(pid); }
    getPlatformOrder() { return _shared_1.PLATFORM_ORDER; }
    getPlatformLabel(pid) { return (0, _shared_1.getPlatformLabel)(pid); }
    getPlatformBestTime(pid) { return (0, _shared_1.getPlatformBestTime)(pid); }
    getPlatformLimit(pid) { var _a, _b; return (_b = (_a = _shared_1.PLATFORM_META[pid]) === null || _a === void 0 ? void 0 : _a.limit) !== null && _b !== void 0 ? _b : 300; }
    getCharFillPct(pid) {
        var _a;
        const text = ((_a = this.generatedContent[pid]) === null || _a === void 0 ? void 0 : _a.text) || '';
        const limit = this.getPlatformLimit(pid);
        return Math.min(100, Math.round((text.length / limit) * 100));
    }
    getGoalLabel(g) { var _a; return ((_a = this.goalOptions.find(opt => opt.key === g)) === null || _a === void 0 ? void 0 : _a.label) || _shared_1.GOAL_LABELS[g] || g; }
    async loadDictionaries() {
        try {
            const response = this.proxy
                ? await this.routeSearchService.callGatedBackend('social-media-dictionary.list', undefined, undefined, 'GET')
                : await this.apiService.back.get('social-media-dictionary.list', { queryParams: { activeOnly: 'true' } });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.toneOptions = response.data.filter(item => item.type === 'tone');
                this.goalOptions = response.data.filter(item => item.type === 'goal');
                this.audienceOptions = response.data.filter(item => item.type === 'audience');
                this.applyDictionaryDefaults();
            }
        }
        catch ( /* silent */_a) { /* silent */ }
    }
    applyDictionaryDefaults() {
        const validGoal = this.goalOptions.some(g => g.label === this.creatorGoal);
        if (!validGoal && this.goalOptions.length > 0) {
            this.creatorGoal = this.goalOptions[0].label;
        }
        const validTone = this.toneOptions.some(t => t.label === this.creatorTone);
        if (!validTone && this.toneOptions.length > 0) {
            this.creatorTone = this.toneOptions[0].label;
        }
        const validAudience = this.audienceOptions.some(a => a.label === this.briefAudience);
        if (!validAudience && this.audienceOptions.length > 0) {
            this.briefAudience = this.audienceOptions[0].label;
        }
    }
    isVisualContentType() { return ['image', 'carousel', 'video', 'story'].includes(this.creatorContentType); }
    pfBadgeHtml(pid, size = 24) { return (0, _shared_1.pfBadge)(pid, size); }
    getPreviewContent(pid) {
        return this.generatedContent[pid] || { text: '', hashtags: [] };
    }
    updatePlatformText(pid, e) {
        const text = e.target.value;
        this.generatedContent = { ...this.generatedContent, [pid]: { ...(this.generatedContent[pid] || { hashtags: [] }), text } };
    }
    handlePlatformTextPaste(pid, e) {
        var _a;
        const clipboardData = e.clipboardData;
        const pasted = (clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('text')) || '';
        if (!pasted)
            return;
        e.preventDefault();
        const { cleanedText, hashtags } = this.extractHashtags(pasted);
        const existing = ((_a = this.generatedContent[pid]) === null || _a === void 0 ? void 0 : _a.hashtags) || [];
        const merged = [...new Set([...existing, ...hashtags])];
        e.target.value = cleanedText;
        this.generatedContent = { ...this.generatedContent, [pid]: { ...(this.generatedContent[pid] || { text: '' }), text: cleanedText, hashtags: merged } };
    }
    extractHashtags(text) {
        const hashtags = [];
        const cleanedText = text
            .replace(/#[\p{L}\p{N}_]+/gu, (match) => {
            hashtags.push(match);
            return '';
        })
            .replace(/\s{2,}/g, ' ')
            .trim();
        return { cleanedText, hashtags };
    }
    updatePlatformHashtags(pid, e) {
        const raw = e.target.value;
        const hashtags = raw.trim() ? raw.trim().split(/\s+/) : [];
        this.generatedContent = { ...this.generatedContent, [pid]: { ...(this.generatedContent[pid] || { text: '' }), hashtags } };
    }
    async generateWithAI() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!this.briefTopic || !this.selectedPlatforms.length) {
            this.notifyService.notify('socialMediaPlan.creator.fillBrief'.t(), 'warning');
            return;
        }
        this.generatingAI = true;
        try {
            const platforms = this.selectedPlatforms.map(p => { var _a; return ((_a = _shared_1.PLATFORM_META[p]) === null || _a === void 0 ? void 0 : _a.label) || p; }).join(', ');
            const prompt = `Jesteś ekspertem od social media. Wygeneruj treść posta dla: ${platforms}.
BRIEF: Temat: ${this.briefTopic}, Cel: ${_shared_1.GOAL_LABELS[this.creatorGoal] || this.creatorGoal}, Ton: ${this.creatorTone}${this.briefAudience ? ', Grupa: ' + this.briefAudience : ''}${this.briefCta ? ', CTA: ' + this.briefCta : ''}${this.briefKeywords ? ', Słowa kluczowe: ' + this.briefKeywords : ''}
Odpowiedź TYLKO jako JSON bez dodatkowego tekstu:
{${this.selectedPlatforms.map(p => { var _a; return `"${p}":{"text":"treść do ${((_a = _shared_1.PLATFORM_META[p]) === null || _a === void 0 ? void 0 : _a.limit) || 300} znaków","hashtags":["#tag1","#tag2"]}`; }).join(',')}}`;
            const aiPayload = {
                messages: [{ role: 'user', content: prompt, timestamp: new Date().toISOString() }],
                context: { approach: 'rrr', selectedModel: { provider: 'openrouter', model: _shared_1.AI_MODEL_SOCIAL }, avatar: null, aiProvider: 'openrouter', language: 'pl', knowledge: [], noTitleGeneration: true, ignoreTools: true },
                stream: false,
            };
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('ai.chat', undefined, aiPayload)
                : await this.apiService.back.post('ai.chat', aiPayload);
            const rawText = ((_c = (_b = (_a = resp === null || resp === void 0 ? void 0 : resp.choices) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.content) || ((_f = (_e = (_d = resp === null || resp === void 0 ? void 0 : resp.data) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.value) || '';
            const match = (typeof rawText === 'string' ? rawText : JSON.stringify(rawText)).match(/\{[\s\S]*\}/);
            if (match) {
                const parsed = JSON.parse(match[0]);
                const content = {};
                for (const pid of this.selectedPlatforms)
                    content[pid] = { text: ((_g = parsed[pid]) === null || _g === void 0 ? void 0 : _g.text) || '', hashtags: ((_h = parsed[pid]) === null || _h === void 0 ? void 0 : _h.hashtags) || [] };
                this.generatedContent = content;
            }
            else {
                this.writeManually();
            }
            this.generatedContentReady = true;
            this.activePreviewPlatform = this.selectedPlatforms[0] || '';
        }
        catch (_j) {
            this.notifyService.notify('socialMediaPlan.creator.aiError'.t(), 'error');
        }
        finally {
            this.generatingAI = false;
        }
    }
    writeManually() {
        const content = {};
        for (const pid of this.selectedPlatforms)
            content[pid] = { text: '', hashtags: [] };
        this.generatedContent = content;
        this.generatedContentReady = true;
        this.activePreviewPlatform = this.selectedPlatforms[0] || '';
    }
    needsVideoUpload() {
        return this.selectedPlatforms.some(p => p === 'youtube' || p === 'tiktok');
    }
    async loadFbPages() {
        var _a;
        if (this.loadingFbPages || this.fbPages.length > 0)
            return;
        this.loadingFbPages = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('settings.social-media.fb.pages', undefined, undefined, 'GET')
                : await this.apiService.back.get('settings.social-media.fb.pages');
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.length)) {
                this.fbPages = resp.data;
                if (!this.selectedFbPageId)
                    this.selectedFbPageId = resp.data[0].id;
                // Store chosen page in facebook content
                this.updateFbPageInContent(this.selectedFbPageId);
            }
        }
        catch ( /* silent */_b) { /* silent */ }
        finally {
            this.loadingFbPages = false;
        }
    }
    selectFbPage(pageId) {
        this.selectedFbPageId = pageId;
        this.updateFbPageInContent(pageId);
    }
    updateFbPageInContent(pageId) {
        if (this.generatedContent['facebook']) {
            this.generatedContent = { ...this.generatedContent, facebook: { ...this.generatedContent['facebook'], pageId } };
        }
    }
    async loadLiPages() {
        var _a;
        if (this.loadingLiPages || this.liPages.length > 0)
            return;
        this.loadingLiPages = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('settings.social-media.li.pages', undefined, undefined, 'GET')
                : await this.apiService.back.get('settings.social-media.li.pages');
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.length)) {
                this.liPages = resp.data;
                if (!this.selectedLiPageId)
                    this.selectedLiPageId = resp.data[0].id;
                this.updateLiPageInContent(this.selectedLiPageId);
            }
        }
        catch ( /* silent */_b) { /* silent */ }
        finally {
            this.loadingLiPages = false;
        }
    }
    selectLiPage(pageId) {
        this.selectedLiPageId = pageId;
        this.updateLiPageInContent(pageId);
    }
    updateLiPageInContent(pageId) {
        if (this.generatedContent['linkedin']) {
            this.generatedContent = { ...this.generatedContent, linkedin: { ...this.generatedContent['linkedin'], liOrgId: pageId } };
        }
    }
    async loadPtBoards() {
        var _a;
        if (this.loadingPtBoards || this.ptBoards.length > 0)
            return;
        this.loadingPtBoards = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('settings.social-media.pt.boards', undefined, undefined, 'GET')
                : await this.apiService.back.get('settings.social-media.pt.boards');
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.length)) {
                this.ptBoards = resp.data;
                if (!this.selectedPtBoardId)
                    this.selectedPtBoardId = resp.data[0].id;
                this.updatePtBoardInContent(this.selectedPtBoardId);
            }
        }
        catch ( /* silent */_b) { /* silent */ }
        finally {
            this.loadingPtBoards = false;
        }
    }
    selectPtBoard(boardId) {
        this.selectedPtBoardId = boardId;
        this.updatePtBoardInContent(boardId);
    }
    updatePtBoardInContent(boardId) {
        if (this.generatedContent['pinterest']) {
            this.generatedContent = { ...this.generatedContent, pinterest: { ...this.generatedContent['pinterest'], ptBoardId: boardId } };
        }
    }
    handleVideoFileSelect(event) {
        var _a;
        const file = (_a = event.data) === null || _a === void 0 ? void 0 : _a.path;
        if (!file)
            return;
        this.pendingVideoFile = file;
        this.videoFileUrl = '';
        this.videoFileId = '';
    }
    clearVideo() {
        this.videoFileUrl = '';
        this.videoFileId = '';
        this.pendingVideoFile = null;
        this.videoUploadProgress = 0;
    }
    clearGeneratedImage() {
        this.generatedImageUrl = '';
        this.generatedImageFileId = '';
        this.imagePrompt = '';
    }
    clearUploadedImage() {
        this.uploadedImageUrl = '';
        this.uploadedImageFileId = '';
    }
    async handleImageFileSelect(event) {
        var _a;
        const file = (_a = event.data) === null || _a === void 0 ? void 0 : _a.path;
        if (!file)
            return;
        this.uploadingImage = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackendUpload('social-media-post.upload-image', undefined, file)
                : await this.apiService.back.uploadFiles('social-media-post.upload-image', { image: file }, {}, { method: 'POST' });
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && resp.data) {
                this.uploadedImageUrl = resp.data.fileUrl;
                this.uploadedImageFileId = resp.data.fileId;
                this.clearGeneratedImage();
            }
            else {
                this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.creator.imageError'.t(), 'error');
            }
        }
        catch (_b) {
            this.notifyService.notify('socialMediaPlan.creator.imageError'.t(), 'error');
        }
        finally {
            this.uploadingImage = false;
        }
    }
    async generateImage() {
        const prompt = this.imagePrompt || this.briefTopic;
        if (!prompt) {
            this.notifyService.notify('socialMediaPlan.creator.imagePromptRequired'.t(), 'warning');
            return;
        }
        this.generatingImage = true;
        try {
            const resp = this.proxy
                ? await this.routeSearchService.callGatedBackend('social-media-post.generate-image', undefined, { prompt })
                : await this.apiService.back.post('social-media-post.generate-image', { prompt });
            if ((resp === null || resp === void 0 ? void 0 : resp.success) && resp.data) {
                this.generatedImageUrl = resp.data.fileUrl;
                this.generatedImageFileId = resp.data.fileId;
            }
            else {
                this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.creator.imageError'.t(), 'error');
            }
        }
        catch (_a) {
            this.notifyService.notify('socialMediaPlan.creator.imageError'.t(), 'error');
        }
        finally {
            this.generatingImage = false;
        }
    }
    async savePost() {
        if (this.finalAction !== 'draft') {
            const ok = await this.checkPlatformConnections();
            if (!ok)
                return;
        }
        // Upload pending video before saving
        if (this.pendingVideoFile && this.needsVideoUpload()) {
            await this.uploadPendingVideo();
            if (this.pendingVideoFile)
                return; // upload failed
        }
        // Upload pending video before saving
        if (this.pendingVideoFile && this.needsVideoUpload()) {
            await this.uploadPendingVideo();
            if (this.pendingVideoFile)
                return; // upload failed — pendingVideoFile not cleared
        }
        this.savingPost = true;
        try {
            let scheduledAt = null;
            if ((this.finalAction === 'scheduled' || this.finalAction === 'needs_review') && this.scheduleDate) {
                scheduledAt = new Date(`${this.scheduleDate}T${this.scheduleTime || '10:00'}`).toISOString();
            }
            if (this.finalAction === 'published')
                scheduledAt = new Date().toISOString();
            const title = this.briefTopic.length > 60 ? this.briefTopic.slice(0, 57) + '…' : (this.briefTopic || 'Nowy post');
            const contentWithImage = {};
            for (const pid of Object.keys(this.generatedContent)) {
                contentWithImage[pid] = {
                    ...this.generatedContent[pid],
                    ...(this.generatedImageFileId || this.uploadedImageFileId ? { imageFileId: this.generatedImageFileId || this.uploadedImageFileId, imageFileUrl: this.generatedImageUrl || this.uploadedImageUrl } : {}),
                    ...((this.videoFileUrl && (pid === 'youtube' || pid === 'tiktok')) ? { videoUrl: this.videoFileUrl, videoFileId: this.videoFileId } : {}),
                    ...(pid === 'facebook' && this.selectedFbPageId ? { pageId: this.selectedFbPageId } : {}),
                    ...(pid === 'linkedin' && this.selectedLiPageId ? { liOrgId: this.selectedLiPageId } : {}),
                    ...(pid === 'pinterest' && this.selectedPtBoardId ? { ptBoardId: this.selectedPtBoardId } : {}),
                };
            }
            const payload = {
                title,
                status: this.finalAction,
                platforms: this.selectedPlatforms,
                brief: { topic: this.briefTopic, goal: this.creatorGoal, tone: this.creatorTone, contentType: this.creatorContentType, audience: this.briefAudience, cta: this.briefCta, keywords: this.briefKeywords, imagePrompt: this.imagePrompt || undefined },
                content: contentWithImage,
                scheduledAt,
            };
            const resp = this.proxy
                ? (this.editingPostId
                    ? await this.routeSearchService.callGatedBackend('social-media-post.update', { id: this.editingPostId }, payload, 'PUT')
                    : await this.routeSearchService.callGatedBackend('social-media-post.create', undefined, payload, 'POST'))
                : (this.editingPostId
                    ? await this.apiService.back.put('social-media-post.update', payload, { routeParams: { id: this.editingPostId }, queryParams: { wsid: this.wsid } })
                    : await this.apiService.back.post('social-media-post.create', payload, { queryParams: { wsid: this.wsid } }));
            if (resp === null || resp === void 0 ? void 0 : resp.success) {
                this.notifyService.notify('socialMediaPlan.post.saved'.t(), 'info');
                this.resetForm();
                this.$emit('post-saved', {});
            }
            else {
                this.notifyService.notify((resp === null || resp === void 0 ? void 0 : resp.error) || 'socialMediaPlan.post.saveFailed'.t(), 'error');
            }
        }
        catch (_a) {
            this.notifyService.notify('socialMediaPlan.post.saveFailed'.t(), 'error');
        }
        finally {
            this.savingPost = false;
        }
    }
};
exports.SmCreatorWizard = SmCreatorWizard;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "creatorOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof _shared_1.IFrontPost !== "undefined" && _shared_1.IFrontPost) === "function" ? _d : Object)
], SmCreatorWizard.prototype, "editingPost", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "proxy", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SmCreatorWizard.prototype, "creatorStep", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "editingPostId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "briefTopic", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "briefAudience", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "briefCta", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "briefKeywords", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "creatorGoal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "creatorTone", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "creatorContentType", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "selectedPlatforms", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof Record !== "undefined" && Record) === "function" ? _e : Object)
], SmCreatorWizard.prototype, "generatedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "generatingAI", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "generatedContentReady", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "activePreviewPlatform", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "finalAction", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "scheduleDate", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "scheduleTime", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "savingPost", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "imagePrompt", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "generatedImageUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "generatedImageFileId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "generatingImage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "uploadedImageUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "uploadedImageFileId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "uploadingImage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "videoFileUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "videoFileId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "uploadingVideo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SmCreatorWizard.prototype, "videoUploadProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof File !== "undefined" && File) === "function" ? _f : Object)
], SmCreatorWizard.prototype, "pendingVideoFile", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], SmCreatorWizard.prototype, "publishingVideoProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "publishingVideoPlatform", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "fbPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "selectedFbPageId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "loadingFbPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "liPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "selectedLiPageId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "loadingLiPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "ptBoards", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmCreatorWizard.prototype, "selectedPtBoardId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmCreatorWizard.prototype, "loadingPtBoards", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof Record !== "undefined" && Record) === "function" ? _g : Object)
], SmCreatorWizard.prototype, "socialMediaStatus", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "toneOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "goalOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmCreatorWizard.prototype, "audienceOptions", void 0);
exports.SmCreatorWizard = SmCreatorWizard = __decorate([
    (0, client_1.RWSView)('sm-creator-wizard', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __param(2, (0, client_1.RWSInject)(_routeSearch_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _b : Object, typeof (_c = typeof _routeSearch_1.RouteSearchServiceInstance !== "undefined" && _routeSearch_1.RouteSearchServiceInstance) === "function" ? _c : Object])
], SmCreatorWizard);
SmCreatorWizard.defineComponent();
